import angular from 'angular';

import component from './experience-test-message.component';

const ExperienceTestMessage = angular
    .module('control-room.experience-promoter.components.experience-manage.components.experience-test-message', [])
    .component('crExperienceTestMessage', component);

export default ExperienceTestMessage;
